import * as React from "react";

import useAuthManager from "./useAuthManager";

export interface SetupProps {
  children?: React.ReactNode;
}

function AuthServicesProvider({ children }: SetupProps) {
  const { isReady } = useAuthManager();

  return <>{isReady && children}</>;
}

export default AuthServicesProvider;
